import { render, staticRenderFns } from "./LoginLayout.vue?vue&type=template&id=46049daa&"
import script from "./LoginLayout.vue?vue&type=script&lang=ts&"
export * from "./LoginLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports